import { PackageSearch } from 'lucide-react'

import { EmptyState } from '@/components/ui'
import { useCart } from '@/contexts/CartContext'
import { PosModel } from '@/types'

import { ProductCard } from './ProductCard'

interface ProductGridProps {
  products?: PosModel.Product[]
  categories?: PosModel.Category[]
  isLoading: boolean
  onAdd: (product: PosModel.Product) => void
}

// Columns follow the panel's own width (the cart is resizable), not the window: as many ~160px tiles as fit.
const grid = 'grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-2'

export const ProductGrid = ({ products, isLoading, onAdd }: ProductGridProps) => {
  const { lines } = useCart()

  // Skeletons match the real card so nothing jumps when data lands.
  if (isLoading && !products)
    return (
      <div className={grid}>
        {Array.from({ length: 10 }, (_, i) => (
          <div key={i} className="min-h-24 overflow-hidden rounded-sm border border-border bg-card">
            <div className="space-y-2 p-2.5">
              <div className="h-4 w-3/4 animate-pulse rounded-xs bg-fill" />
              <div className="h-4 w-1/3 animate-pulse rounded-xs bg-fill" />
              <div className="h-5 w-16 animate-pulse rounded-sm bg-fill" />
            </div>
          </div>
        ))}
      </div>
    )

  if (!products?.length)
    return (
      <EmptyState icon={PackageSearch} title="No products found" className="py-16">
        Try a different name or SKU, or scan the barcode.
      </EmptyState>
    )

  return (
    <div className={grid}>
      {products.map((p) => (
        <ProductCard
          key={p._id}
          product={p}
          inCart={lines.find((l) => l.product._id === p._id)?.quantity}
          onAdd={onAdd}
        />
      ))}
    </div>
  )
}
